import styled from 'styled-components';
import MyCashSvg from '../../assets/wallet/ic-my-cash.svg';

const MyCashIcon = styled(MyCashSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
    width: ${props => props.width || '3.5rem'};
    height: ${props => props.height || '3.5rem'};
`;

export default MyCashIcon;
